module.exports = __webpack_public_path__ + "static/media/logo_updated_cream.12fe0e1b.svg";